import React, { Component } from 'react'
import PropTypes from 'prop-types'
import filterHoc from './index'

const HideElement = props => {
  let {
    loading,
    children
  } = props
  let style = {}

  if (!loading) style.display = 'none'

  return (
    <div style={style}>
      { children }
    </div>
  )
}

export default filterHoc(HideElement)
